import { Box, ColorOptions, Loader, Spacer, Text } from '@jfs/ui-new'
import { useFocusEffect, useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { ExpandAddView } from '../../components/ExpandAddView'
import { List } from '../../components/List'
import { useLazyApiData, useStores } from '../../data/store'
import { isAccessible } from '../../utils'
import { filterData } from '../../utils/constants'
import { MerchantForm } from './MerchantForm'

type filterType = {
  [key: string]: string
}

const ProcessingEntity = () => {
  const [isLoading, setLoading] = useState(false)
  const [isExpand, setIsExpand] = useState(false)
  const [merchant, setMerchant] = useState<any>({})

  const { getAll, entityList, accessConfig, config } = useStores((store) => ({
    getAll: store?.processingEntity?.getAll,
    entityList: store?.processingEntity?.getEntityList,
    config: store?.user?.accessConfig,
    accessConfig: store.user.getAccessConfig(['ess', 'processing_entity']),
  }))

  const [listData, setListData] = useState<any>([])
  const [lazyGetAll, { state, data }] = useLazyApiData(getAll)

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {

      setListData(entityList(data?.processingEntity ?? []))
    }
  }, [entityList, state])
  useFocusEffect(
    useCallback(() => {
      if (isAccessible(accessConfig, 'fetch')) {
        setLoading(true)
        lazyGetAll()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]),
  )

  useEffect(() => {
    if (state === 'fulfilled' || state === 'rejected') {
      setLoading(false)
    }
  }, [state])

  const keyExtractor = (item: any): string => {
    return item.id
  }

  const headTitles = [
    { ID: 'ID' },
    { credentials: 'Credentials' },
    { endpoint: 'Endpoint' },
    { integrationMethod: 'Integration Method' },
    { name: 'Name' },
  ]

  const navigation = useNavigation()
  const onPress = (item: any) => {
    setMerchant(item)
    navigation.navigate('processingentitydetails', { id: item.ID })
  }

  const getMappingList = () => {
    if (isLoading) {
      return <Loader />
    }
    return (
      <Box>
        <List
          keyExtractor={keyExtractor}
          headTitle={headTitles}
          numOfColumns={5}
          sizeConfig={[1, 2, 1.75, 1.75, 1.75]}
          data={listData}
          onPress={onPress}
          filterData={filterData}
          listTitle={'Processing Entity List'}
          isColumnSearchEnabled={true}
          getFilteredData={entityList}
        />
      </Box>
    )
  }

  const onUpdate = () => {
    setIsExpand(false)
    lazyGetAll()
  }

  const onAdd = () => {
    if (isExpand) {
      setIsExpand(false)
      lazyGetAll()
    }
    
  }

  return (
    <Box>
      <Text title={'Processing Entity'} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction="vertical" size={24} />
      {isAccessible(accessConfig, 'add') && (
        <ExpandAddView
          children={
            <MerchantForm
              id={merchant.ID}
              onUpdate={onAdd}
              isEditable={isAccessible(accessConfig, 'update')}
              isDeletable={isAccessible(accessConfig, 'delete')}
            />
          }
          isExpand={isExpand}
          setIsExpand={setIsExpand}
          title={'Add New Mapping'}
        />
      )}
      <Spacer direction="vertical" size={16} />
      {isAccessible(accessConfig, 'fetch') && getMappingList()}
    </Box>
  )
}

export default ProcessingEntity
